import validatableWithSyncInitialize from './validatableWithSyncInitialize';
import {valueValidatableClearance} from './valueValidatableInitialize';

const checkboxGroupInitialize = (RMI, contextId, compId) => validatableWithSyncInitialize(RMI, contextId, compId);

const checkboxGroupClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {checkboxGroupInitialize, checkboxGroupClearance};
